import { render } from "./AssetTypeVideo.vue?vue&type=template&id=05a46132"
import script from "./AssetTypeVideo.vue?vue&type=script&lang=js"
export * from "./AssetTypeVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/brandacumen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__